export default "__VITE_ASSET__3946a250__"